import { Presenter } from '@d-id/types';

const DEFAULT_PRESENTER = 'v2_public_amber@Y5K02DLS4m';

export const getDefaultAgentPresenter = (presenters: Presenter[] | undefined) => {
    return presenters?.find(({ id }) => id === DEFAULT_PRESENTER && !id?.includes('-removed_bg'));
};
